import history from 'services/history';
import { getDatabasesService, updateDatabaseService } from 'services/database';

export const setLoading = (dispatch, value) => {
  dispatch({
    type: 'SET_LOADING',
    payload: value,
  });
};

const mapPriorityStatus = (priority: number) => {
  switch (priority) {
    case 0:
      return undefined;
    case 1:
      return false;
    case 2:
      return true;
    default:
      true;
  }
};

export const getDatabases = async (
  dispatch,
  page,
  search,
  filter,
  clouds,
  order,
  ctrl,
) => {
  setLoading(dispatch, true);
  try {
    const { data } = await getDatabasesService(
      {
        ...search,
        page,
        filter,
        clouds,
        [`${order?.column}_order`]: mapPriorityStatus(order?.value),
      },
      ctrl,
    );

    dispatch({
      type: 'GET_DATABASES',
      payload: data,
    });
    setLoading(dispatch, false);
  } catch (e) {
    if (e.message !== 'canceled') setLoading(dispatch, false);

    if (e?.response?.status === 404) {
      history.push('/404');
    }
  }
};

export const updateDatabase = async (dispatch, field, value, id) => {
  try {
    const { data } = await updateDatabaseService(id, {
      [field]: value,
    });

    dispatch({
      type: 'UPDATE_DATABASE',
      payload: data,
    });
  } catch (e) {
    dispatch({
      type: 'UPDATE_DATABASE_ERROR',
      payload: e?.response?.data,
    });
  }
};

export const updateDatabaseField = (dispatch, field, value, id) => {
  try {
    dispatch({
      type: 'UPDATE_DATABASE_FIELD',
      payload: { field, value, id },
    });
  } catch (e) {
    dispatch({
      type: 'UPDATE_DATABASE_ERROR',
      payload: e?.response?.data,
    });
  }
};
